module.exports = "<iframe src=\"http://vivox-docs.s3-website-us-west-2.amazonaws.com/\">\n</iframe>\n"